module.exports = __webpack_public_path__ + "static/media/hero_img_internal_mobility.b9581f13.png";